import { MapPin, Check, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { PROJECTS, SITE } from "@/data/content";

export default function Projects() {
  const waFor = (p) =>
    `${SITE.whatsapp}?text=${encodeURIComponent(
      `Hello Sunil ji, I want details for the featured project: ${p.name} (${p.location}). Please share current availability and pricing.`
    )}`;

  return (
    <section id="projects" className="py-24 lg:py-32 bg-navy relative overflow-hidden" data-testid="projects-section">
      <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full border border-gold/10 pointer-events-none" />
      <div className="absolute -bottom-56 -left-40 w-[620px] h-[620px] rounded-full border border-gold/10 pointer-events-none" />
      <div className="container-luxe relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-6">
          <Reveal className="lg:col-span-8">
            <p className="eyebrow !text-gold mb-4">Featured Projects</p>
            <h2 className="font-serif font-semibold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              A Glimpse of What's Emerging in Dholera
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4">
            <p className="text-white/60 leading-relaxed text-sm">
              Indicative showcases of the property types we deal in. Project names, approvals and inventory are published only after finalization.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-gold/80 border-l-2 border-gold pl-4 leading-relaxed mb-12">
            Placeholder showcases — actual project details will be published once finalized. Enquire for current, verified options.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="projects-grid">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.name} delay={0.1 * i} y={44} className="group relative bg-navy-2 border border-white/10 rounded-sm overflow-hidden hover:border-gold/50 transition-colors duration-300">
              <div className="relative h-60 overflow-hidden">
                <img src={p.image} alt={p.alt} loading="lazy" className="w-full h-full object-cover img-treatment transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-2 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 glass-dark text-gold font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
                  {p.type}
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-serif text-2xl text-white font-semibold">{p.name}</h3>
                <p className="mt-2 flex items-center gap-2 text-white/60 text-sm">
                  <MapPin className="w-4 h-4 text-gold shrink-0" /> {p.location}
                </p>
                <p className="mt-3 font-mono text-xs text-gold tracking-wide">Plot sizes: {p.sizes}</p>
                <ul className="mt-4 space-y-2">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
                      <Check className="w-4 h-4 text-gold mt-0.5 shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <a
                  href={waFor(p)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`project-enquire-${i}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-gold border-b-2 border-gold/50 pb-1 hover:border-gold transition-colors duration-300"
                >
                  Enquire <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
